/*@flow*/
import type { Node } from 'react';
import React from 'react';
import Snackbar from 'comps/Snackbar';
import { unset, set } from 'ops';
import useStoreState from 'lib/useStoreState';

export default (): Node => {
  const { type, message, duration } = useStoreState({
    type: 'ui.toaster.type',
    message: 'ui.toaster.message',
    duration: 'ui.toaster.duration',
  });

  const isOpen = ['Open'].includes(type);

  function onRequestClose() {
    set('ui.toaster.type', 'Closed');
    unset('ui.toaster.message');
  }

  function dismiss() {
    set('ui.toaster.type', 'Closed');
  }

  const dismissBtn = (
    <a
      id="dismiss-toaster"
      style={{ color: 'white' }}
      onClick={dismiss}
      className="float-right"
    >
      <span className="fa fa-times" />
    </a>
  );

  return (
    <Snackbar
      open={isOpen}
      message={
        <div>
          {message} {dismissBtn}
        </div>
      }
      id="toaster"
      autoHideDuration={duration}
      onRequestClose={onRequestClose}
    />
  );
};
